import type { Objective } from './use-objectives'
import { DialogPhase } from '../models/dialog/dialog'

export type ArchiveHintReason = 'reopen' | 'dialogHistory'

export interface ObjectiveControls {
  readonly showDelete: boolean
  readonly showEdit: boolean
  readonly showActionsEdit: boolean
  readonly showAchieve: boolean
  readonly showReopen: boolean
  readonly showArchive: boolean
  readonly showRestore: boolean
  readonly showPromote: boolean
  readonly showArchiveInFooter: boolean
  readonly archiveHint: ArchiveHintReason | null
}

export const getObjectiveControls = (
  objective: Objective,
  options: { isReadOnly: boolean; currentUserId: string; dialogPhase?: DialogPhase },
): ObjectiveControls => {
  const readOnly = options.isReadOnly
  const achieved = !!objective.achievedAt
  const archived = !!objective.archivedAt
  const isImpulse = objective.isImpulse

  const showEdit = !readOnly && !achieved && !archived
  const showArchive = !readOnly && !archived && !isImpulse && achieved
  const showDelete = !readOnly && objective.canDelete
  const showArchiveInFooter = showArchive && !showDelete

  let archiveHint: ArchiveHintReason | null = null
  if (showArchive && !objective.canDelete) {
    if (achieved) {
      archiveHint = 'reopen'
    } else if (objective.author?.id === options.currentUserId) {
      archiveHint = 'dialogHistory'
    }
  }

  const phase = options.dialogPhase
  const showPromote =
    !readOnly && isImpulse && phase === DialogPhase.Conversation

  return {
    showDelete,
    showEdit,
    showActionsEdit: showEdit,
    showAchieve: !readOnly && !achieved && !archived && !isImpulse,
    showReopen: !readOnly && achieved && !archived,
    showArchive,
    showRestore: !readOnly && archived,
    showPromote,
    showArchiveInFooter,
    archiveHint,
  }
}
